import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-primary px-4 py-2 text-uppercase",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goLogin()))
  }, _toDisplayString(_ctx.t(_ctx.text)), 1))
}